var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogosCss3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 111,
    viewBox: "0 0 79 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3155 110.72L7.2804 101.827L0.141357 21.7591H78.5856L71.4392 101.814L39.3155 110.72Z",
    fill: "#264DE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3211 96.7166L71.4279 28.3055H39.3635V103.913L65.3211 96.7166Z",
    fill: "#2965F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5072 58.0017L17.3873 67.8217H39.3634V58.0017H16.5072ZM14.7385 38.1259L15.6312 47.9459H39.3634V38.1259H14.7385ZM39.3634 83.5053L39.3204 83.5166L28.3835 80.5636L27.6842 72.7318H17.8261L19.2018 88.1507L39.3182 93.7345L39.3634 93.7222V83.5053Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6028 0H30.4966V4.97378H23.5768V9.94757H30.4972V14.921H18.6028V0ZM32.8756 0H44.7697V4.325H37.8496V5.18994H44.7697V15.1375H32.8759V10.5957H39.796V9.73079H32.8753L32.8756 0ZM47.1488 0H59.0429V4.325H52.1228V5.18994H59.0429V15.1375H47.1488V10.5957H54.0689V9.73079H47.1491L47.1488 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1569 58.0017L63.9296 38.1259H39.3297V47.9459H53.1674L52.2738 58.0017H39.3297V67.8217H51.4224L50.2822 80.5575L39.3293 83.5136V93.7299L59.4618 88.1507L59.6094 86.4915L61.9174 60.6387L62.1569 58.0017Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.73,
    height: 111,
    fill: "white",
    transform: "translate(-0.00158691)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosCss3);
export default __webpack_public_path__ + "static/media/logos_css-3.b06a4117051d547835d4313107485eff.svg";
export { ForwardRef as ReactComponent };